import React from 'react'
import PropTypes from 'prop-types'

import Asterisk from '../Asterisk'
import FieldError from '../FieldError'

const DateInput = ({
  name,
  label,
  required,
  values,
  errors,
  touched,
  className = '',
  inputClassName = '',
  disabled = false,
  readOnly = false,
  onChange = () => { },
  onBlur = () => { },
  buttonGroup = '',
  size,
  inline = false,
  popover = null,
  labelWidth = 6,
  inputWidth = 6,
  max = '9999-12-31',
  dataPrivate = true
}) => {
  let sizeClass = ''
  if (size === 'lg') {
    sizeClass = 'form-control-lg'
  } else if (size === 'sm') {
    sizeClass = 'form-control-sm'
  }

  let inputContent = (
    <input
      type='date'
      name={name}
      id={name}
      max={max}
      value={values[name]}
      className={`form-control ${sizeClass} ${inputClassName}`}
      disabled={disabled}
      onChange={onChange}
      onBlur={onBlur}
      aria-label={name}
      aria-required={required}
    />
  )

  if (buttonGroup) {
    inputContent = (
      <div className='input-group'>
        <div className='input-group-text' id={name}>{buttonGroup}</div>
        {inputContent}
      </div>
    )
  }

  let containerClassName = `form-group col-12 rounded ${className}`
  if (!disabled && !readOnly && errors[name] && touched[name]) {
    containerClassName += ' has-danger'
  }
  if (readOnly) {
    containerClassName += ' bg-light-hover read-only'
  }
  if (inline) {
    containerClassName += ' row'
  }

  let labelClassName = 'form-label'
  if (inline) {
    labelClassName += ` col-12 col-sm-${labelWidth}`
    if (readOnly) {
      labelClassName += ' mb-0'
    }
  } else {
    labelClassName += ' mb-0'
  }

  return (
    <div className={containerClassName}>
      <label htmlFor={name} className={labelClassName}>
        {label}{readOnly && ':'}{required && !readOnly && <Asterisk />}
      </label>
      {popover}
      <div className={`${inline ? `col-12 col-sm-${inputWidth}` : ''}`} data-private={dataPrivate}>
        {readOnly
          ? <span>{values[name]}</span>
          : (
            <>
              {inputContent}
              <FieldError error={errors[name]} touched={touched[name]} disabled={disabled} />
            </>
          )
        }
      </div>
    </div>
  )
}

DateInput.propTypes = {
  required: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  buttonGroup: PropTypes.any,
  size: PropTypes.string,
  inline: PropTypes.bool,
  labelWidth: PropTypes.number,
  inputWidth: PropTypes.number,
  max: PropTypes.string,
  popover: PropTypes.any,
  dataPrivate: PropTypes.bool
}

export default DateInput
